/* eslint-disable @typescript-eslint/no-explicit-any */
import { API_BASE, STORAGE_BASE } from '../config/env';
import { httpConstants } from '../constants';
import cipherServiceInstance from '../services/cipherService';
import { httpService } from '../utility/httpService';

export interface DiagramData {
  xmlData: string;
  useCaseId: string;
}

export interface UseCaseAiPportunityData {
  useCaseId: string;
}

export interface DiagramStorageData {
  xmlUrl: string;
  diagramId?: string;
  diagramUrl?: string;
}
export interface fetchTechLandscapeDiagram {
  organization_id: string;
  diagram_xml: string;
  step_descriptions: any;
  ai_opportunities: any[];
}

interface OpportunityPayload {
  useCase: string;
  opportunities: Array<{
    id: string;
    name: string;
    description: string;
    shape_id: string;
    checked?: boolean;
    valid?: boolean;
    data?: {
      knowledgeData: string[];
      'PoC Complexity': string;
    };
  }>;
}

export async function getAiOpportunityByDiagramId(
  diagramId: string
): Promise<DiagramData | undefined> {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/ai_opportunity/?diagram=${encodeURIComponent(diagramId)}`;

  try {
    const response = await httpService<DiagramData>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}

export async function getUseCaseDiagramDetailsByDiagramId(
  diagramId: string
): Promise<DiagramData | undefined> {
  const url = `${API_BASE}/api/v1/use_case/diagram/${encodeURIComponent(diagramId)}/`;

  try {
    const response = await httpService<DiagramData>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}

// export async function saveDiagram(diagramId: string, diagramData: any): Promise<any> {
//   const url = `${API_BASE}/api/v1/use_case/diagram/${encodeURIComponent(diagramId)}/`;

//   try {
//     const response = await httpService<any>(
//       httpConstants.METHOD_TYPE.PATCH,
//       url,
//       diagramData
//     );
//     return response;
//   } catch (error) {
//     console.error('Failed to save diagram data:', error);
//     throw error;
//   }
// }

export async function saveDiagram(diagramId: string, diagramData: any): Promise<any> {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/diagram/${encodeURIComponent(diagramId)}/`;

  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.PATCH, url, diagramData);
    return response;
  } catch (error) {
    console.error('Failed to save diagram data:', error);
    throw error;
  }
}

export async function getDiagramXML(xmlData: string): Promise<DiagramData | undefined> {
  const url = `${STORAGE_BASE}${xmlData}`;
  try {
    const response = await httpService<DiagramData>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}

export async function fetchDiagramData(
  xmlUrl: string,
  diagramId: string
): Promise<{ xml: string }> {
  const isUseCaseDiagram = xmlUrl.includes('use_case/diagram/xml');
  const combinedUrl = isUseCaseDiagram ? `${xmlUrl}` : `${STORAGE_BASE}${xmlUrl}`;
  const emptyDiagram: string = `<?xml version="1.0" encoding="UTF-8"?>`;
  const encryptedXml = cipherServiceInstance.encrypt(combinedUrl);
  const secretKey = cipherServiceInstance.getSecretKey();
  const url = `${API_BASE}/api/v1/storage/${secretKey}/`;
  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.POST, url, {
      url: encryptedXml,
    });
    const decryptedData = cipherServiceInstance.decrypt(response?.xml);
    return { xml: decryptedData };
  } catch (error) {
    if (diagramId) {
      try {
        const diagramDataUrl = `${STORAGE_BASE}/e2e_taxonomy/ai_opportunity/${diagramId}`;
        const encryptedXml = cipherServiceInstance.encrypt(diagramDataUrl);
        const diagramData = await httpService<any>(httpConstants.METHOD_TYPE.POST, url, {
          url: encryptedXml,
        });
        const decryptedData = cipherServiceInstance.decrypt(diagramData?.xml);
        return { xml: decryptedData };
      } catch {
        return { xml: emptyDiagram };
      }
    }
    return { xml: emptyDiagram };
  }
}

export async function updateAIOpportunityCheckedStatus(
  checkedOpportunities: OpportunityPayload
): Promise<any> {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/ai_opportunity/`;

  try {
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.POST,
      url,
      checkedOpportunities
    );
    return response;
  } catch (error) {
    console.error('Failed to update AI opportunity checked status:', error);
    throw error;
  }
}

export async function getAiOpportunityByUseCaseId(
  usecaseId: string
): Promise<DiagramData | undefined> {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/ai_opportunity/?useCase=${encodeURIComponent(usecaseId)}`;

  try {
    const response = await httpService<DiagramData>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}
export async function fetchTechLandscapeDiagram(
  payload: fetchTechLandscapeDiagram
): Promise<fetchTechLandscapeDiagram | undefined> {
  const url = `${API_BASE}/api/v1/tech_landscape/diagram/`;
  try {
    const response = await httpService<fetchTechLandscapeDiagram>(
      httpConstants.METHOD_TYPE.POST,
      url,
      payload
    );
    console.log('Tech Landscape Diagram Response:', response);
    return response;
  } catch (error) {
    console.error('Failed to fetch tech landscape diagram:', error);
    return undefined;
  }
}
